import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import { makeStyles } from "@mui/styles";
import FormHelperText from '@mui/material/FormHelperText';

export default function ExpenseDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const currencyRegEx = /^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/;

    const [poChoices, setPoChoices] = React.useState([])
    const [labChoices, setLabChoicesDataset] = React.useState([])
    const [invoices, setInvoicesDataSet] = React.useState([]);

    const initialValues = {
		Name:'',
        Invoice: '',
        Lab: '',
        Comment: '',
        Date: '',        
        Amount: ''
    };
    
   /* const useStyles = makeStyles((theme) => ({
	  root: {
	    '& .MuiInputBase-root': {
	     	backgroundColor: "#FFFFFF",
            padding: '5px 10px 5px',
            height: '100px',
            
	    },
	  },
	}));*/
	
	/*const classes = useStyles();*/

    const validFormSchema = Yup.object({
		Name: Yup
            .string('Enter a Name to this expense ')
            .required('Name is required'),
        Invoice: Yup
            .string('Enter a name for the expense'),
        Lab: Yup
            .string('Enter a lab for the expense')
            .required('Lab is required'),
        Comment: Yup
            .string('Enter a name for the expense'),
        Date: Yup
            .date('Enter a date for this expense')
            .required('Date is required'),        
        Amount: Yup.number().test(
            'is-Currency',
            'invalid Currency',
            value => (value.toFixed(2)+"").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/),
        ),
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
			Name: values.Name,
            Invoice: values.Invoice,
            Lab: values.Lab,
            Comment: values.Comment,
            Amount: parseFloat(values.Amount).toFixed(2),
            Date: moment.utc(values.Date)
        };

        handleDialogCallback(msg);        
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPoChoices(choices)
    }

    const setLabChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setLabChoicesDataset(choices)
    };
    
    const setInvoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.InvoiceNumber, value: choice.ID }))
        setInvoicesDataSet(choices)
    };

    React.useEffect(() => {
        if (refresh) {
            fetch('api/PO/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json));

            fetch('api/lab/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setLabChoices(json));
                
            fetch('api/Invoice', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setInvoices(json))

            setRefresh(false);
        }
    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Expense
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        validateOnChange={false}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                            Expense
                                        </Typography>
                                        <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Expense Info:</DialogTitle>
                                <div>
                                	<FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name='Name'
                                            id="outlined-ExpenseName"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && !Boolean(props.values.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="ExpenseName"
                                        />
                                         {props.touched.Name && !Boolean(props.values.Name) &&
													<FormHelperText error={true}>Enter a Name to this expense</FormHelperText>}
                                    </FormControl>
                                     <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-Lab">Lab</InputLabel>
                                        <CustomSelect
                                            name='Lab'
                                            id="outlined-Lab"
                                            options={labChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Lab}
                                            error={props.touched.Lab && !Boolean(props.values.Lab)}
                                            helperText={props.touched.Lab && props.errors.Lab}
                                            label="Lab"
                                        />
                                         {props.touched.Lab && !Boolean(props.values.Lab) &&
													<FormHelperText error={true}>Please select Lab Name </FormHelperText>}
                                    </FormControl>
                                    
                                </div>
                                <div>
                                        <FormControl  sx={{ m: 1, width: 220 }}>  
                                        <TextField
                                            name='Invoice'
                                            id="outlined-Invoice"                             
                                            label="Invoice"
                                            defaultValue=""
                                            disabled
                                        />
                                    </FormControl>
                    				   <FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name='Amount'
                                            id="outlined-Amount"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Amount}
                                            error={props.touched.Amount && !Boolean(props.values.Amount)}
                                            helperText={props.touched.Amount && props.errors.Amount}
                                            label="Amount"
                                        />
                                         {props.touched.Amount && !Boolean(props.values.Amount) &&
													<FormHelperText error={true}>Please enter Amount </FormHelperText>}
                                    </FormControl>
                        
                                   
                                </div>
                                <div>
                                 <FormControl  /*className={classes.root} */ sx={{ m: 1 , width: 220}}>                                        
                                        <TextField
                                            name='Comment'
                                            id="outlined-Comment"
                                            multiline
                                            row={4}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Comment}
                                            label="Comment"
                                        />
                                     
                                    </FormControl>
                                    
                                   <FormControl  sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name='Date'
                                            id="outlined-Date" 
                                            type="date"                               
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Date}
                                            error={props.touched.Date && !Boolean(props.values.Date)}
                                            helperText={props.touched.Date && props.errors.Date}
                                            label="Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                         {props.touched.Date && !Boolean(props.values.Date) &&
													<FormHelperText error={true}>Please enter the Date</FormHelperText>}
                                    </FormControl>
                                    
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                      
                
            </Dialog>
        </div>
    );
}